import { render, staticRenderFns } from "./UserSettingsApps.vue?vue&type=template&id=58ebeb40&scoped=true&"
import script from "./UserSettingsApps.vue?vue&type=script&lang=js&"
export * from "./UserSettingsApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ebeb40",
  null
  
)

export default component.exports